import { css } from '@rxdi/lit-html';

export const ReactRevealAnimation = css`
  @keyframes react-reveal {
    0% {
      opacity: 0;
      transform: translate3d(0px, 40px, 0px);
    }
    100% {
      opacity: 1;
      transform: none;
    }
  }
`;
